import { React, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'normalize.css';

const AssembleCreate = () => {
  const navigate = useNavigate();

  const [assembleData, setAssembleData] = useState({
    machineModel: "",
    machineForm: "",
    dataId: "",
    measurementTime: "",
    deliveryTime: "",
    measurementLocation: "",
  });

  const handleFileChange = async (e, fileKey) => {
    const file = e.target.files[0];
    try {
      const imageData = await convertToBase64(file);
      setAssembleData((prev) => ({ ...prev, [fileKey]: imageData }));
      console.log("Converted Image Data:", assembleData);
    } catch (error) {
      console.error("Error converting file:", error);
    }
  };

  const onAssembleManagement = (e) => {
    e.preventDefault();
    navigate('/assemble-management');
  };

  const onAssembleManagementFRF = (e) => {
    e.preventDefault();
    localStorage.setItem("assembleData", JSON.stringify(assembleData));
    //alert("已儲存變更");
    console.log('基本資料傳遞', assembleData)
    navigate('/assemble-frequency-response-function/x', { state: { assembleData } });
  };

  useEffect(() => {
    const savedData = localStorage.getItem("assembleData");
    if (savedData) {
      setAssembleData(JSON.parse(savedData));
    }
  }, []);

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve({ image: reader.result });
      };

      reader.onerror = (error) => {
        console.error("Error reading file:", error);
        reject(error);
      };
    });
  };

  const handleChange = (event) => {
    const { id, value } = event.target;
    setAssembleData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  return (
    <div className="d-flex flex-column flex-md-row" style={{ width: '81.7%', margin: '0 auto' }}>
      <div className="container-fluid">
        <div style={{ height: '35px', width: '100%' }}></div>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item" >
              <a href="#" onClick={onAssembleManagement} style={{ color: '#B0B7C3', fontWeight: 'bold', fontSize: '15px' }}>組裝資料庫</a>
            </li>
            <li
              className="breadcrumb-item"
              aria-current="page"
              style={{ color: '#5B82B1', fontWeight: 'bold', fontSize: '15px' }}>新增資料
            </li>
          </ol>
        </nav>

        <div style={{ height: '10px', width: '100%' }}></div>

        <form >
          <div className=" d-flex flex-column">
            <span className="sub-title">基本資料</span>
            <div style={{ height: '35px', width: '100%' }}></div>

            <div className="d-flex flex-column flex-md-row">
              <div className="p-1 flex-fill">
                <div className="row mb-3">
                  <label htmlFor="dataId" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }} >資料ID</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="dataId" value={assembleData.dataId} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="deliveryTime" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }} >交機時間</label>
                  <div className="col-sm-9">
                    <input type="datetime-local" className="form-control" id="deliveryTime" value={assembleData.deliveryTime} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="measurementLocation" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }} >測量地點</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="measurementLocation" value={assembleData.measurementLocation} onChange={handleChange} />
                  </div>
                </div>

              </div>

              <div className="p-1 flex-fill">
                <div className="row mb-3">
                  <label htmlFor="machineModel" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }} >機台型號</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="machineModel" value={assembleData.machineModel} onChange={handleChange} />
                  </div>
                </div>

                <div className=" row mb-3">
                  <label htmlFor="machineForm" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }} >機台形式</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="machineForm" value={assembleData.machineForm} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="measurementTime" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }} >測量時間</label>
                  <div className="col-sm-9">
                    <input type="datetime-local" className="form-control" id="measurementTime" value={assembleData.measurementTime} onChange={handleChange} />
                  </div>
                </div>
              </div>
            </div>

            <div style={{ height: '35px', width: '100%' }}></div>

            <span className="sub-title">測量記錄</span>
            <div style={{ height: '35px', width: '100%' }}></div>

            <div className="row mb-3 align-items-center">
              <label htmlFor="formFile_1" className="col-sm-1 col-form-label" style={{ minWidth: "100px" }}>量測點位</label>
              <div className="col" style={{ flex: "0 0 87.5%" }}>
                <input type="file" className="form-control" id="formFile_1" accept="image/*" onChange={(e) => handleFileChange(e, 'measurementPointFile')} />
              </div>
            </div>

            <div className="row mb-3 align-items-center">
              <label htmlFor="formFile_2" className="col-sm-1 col-form-label" style={{ minWidth: "100px" }}>敲擊位置</label>
              <div className="col" style={{ flex: "0 0 87.5%" }}>
                <input type="file" className="form-control" id="formFile_2" accept="image/*" onChange={(e) => handleFileChange(e, 'impactPositionFile')} />
              </div>
            </div>

            <div className="row mb-3 align-items-center">
              <label htmlFor="formFile_3" className="col-sm-1 col-form-label" style={{ minWidth: "100px" }}>機台型式</label>
              <div className="col" style={{ flex: "0 0 87.5%" }}>
                <input type="file" className="form-control" id="formFile_3" accept="image/*" onChange={(e) => handleFileChange(e, 'machineImageFile')} />
              </div>
            </div>
          </div>

          <div style={{ height: '15px', width: '100%' }}></div>

          <div className="d-flex justify-content-end gap-3" style={{ paddingRight: "60px" }}>
            <button
              className="btn-cancel"
              style={{ height: '35px', width: '60px' }}
              onClick={onAssembleManagement}
              type="button"
            >
              取消
            </button>
            <button
              className="btn-confirm btn-primary"
              style={{ height: '35px', width: '60px' }}
              onClick={onAssembleManagementFRF}
              type="button"
            >
              下一步
            </button>
          </div>
          <div style={{ height: '60px', width: '100%' }}></div>
        </form>
      </div>
    </div>
  );
};

export default AssembleCreate;